module.exports = __webpack_public_path__ + "img/2.bbc9f836.jpeg";